export default {
  AD: "ad",
  SLATE: "slate",
  DISCLAIMER: "disclaimer",
};
